import { useMultiLocationUtils, useSelectedLocations } from '@frontend/payments-hooks';
import { LocationCountChip } from '../../Shared';

export const LocationCountChipForToggle = ({ enabledLocationIds }: { enabledLocationIds: string[] }) => {
  const { locationIds } = useSelectedLocations();
  const { getLocationName } = useMultiLocationUtils();

  if (locationIds.length === enabledLocationIds.length) return null;
  return <LocationCountChip locationIds={enabledLocationIds} getLocationName={getLocationName} />;
};
